import React from "react";
import DataList from "../../../components/DataList/DataList";

function ActiveTab({title,tab, totalItens, paginaAtual, setPaginaAtual,itensPorPagina, datas, onEdit, onDelete  }) {
    return (
          <DataList 
            title={title} 
            datas={datas}  
            tab={tab}
            onEdit={onEdit} 
            totalCount={totalItens}
            paginaAtual={paginaAtual}
            setPaginaAtual={setPaginaAtual}
            itensPorPagina={itensPorPagina}  
            onDelete={onDelete} />
      );
}

export default ActiveTab;